import { lazy } from 'react'

import type { RouteObject } from 'react-router'

const PropostaChilePage = lazy(() =>
  import('@/features/proposta/chile/pages/criar-proposta').then((module) => ({
    default: module.PropostaChilePage,
  })),
)

export const chilePropostaRoutes: RouteObject[] = [
  {
    path: 'es-CL/proposta',
    children: [
      {
        index: true,
        element: <PropostaChilePage />,
      },
    ],
  },
]
